<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 社区管理轮播图 -->
    <CommunityAdminBanner></CommunityAdminBanner>
    <!-- 社区管理痛点 -->
    <CommunityAdminPainPoint></CommunityAdminPainPoint>
    <!-- 解决方案提供 -->
    <Programme></Programme>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/pc/components/TopNav.vue";
import ButtonNav from "../../../../components/pc/components/BottomNav.vue";
import CommunityAdminBanner from '../../../../components/pc/Programme/CommunityAdminComponents/CommunityAdminBanner.vue'
import CommunityAdminPainPoint from '../../../../components/pc/Programme/CommunityAdminComponents/CommunityAdminPainPoint.vue'
import Programme from '../../../../components/pc/Programme/CommunityAdminComponents/Programme.vue'

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    CommunityAdminBanner,
    CommunityAdminPainPoint,
    Programme,
  },
};
</script>

<style scoped>
</style>
